import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M8.25 9.75H4.5a.73.73 0 0 1-.535-.216A.72.72 0 0 1 3.75 9q0-.319.216-.535A.72.72 0 0 1 4.5 8.25h3.75V4.5q0-.318.216-.535A.72.72 0 0 1 9 3.75q.319 0 .535.216a.72.72 0 0 1 .215.534v3.75h3.75q.319 0 .535.216A.72.72 0 0 1 14.25 9q0 .319-.216.535a.72.72 0 0 1-.534.215H9.75v3.75q0 .319-.216.535A.72.72 0 0 1 9 14.25a.73.73 0 0 1-.535-.216.72.72 0 0 1-.215-.534z"
    }, null, -1)
  ]))]))
}
export default { render: render }